// bootstrap css
import "bootstrap/dist/css/bootstrap.min.css";
// bootstrap js
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "swiper/css";
import "swiper/css/pagination";

// custom global styles
import "./src/styles/global.scss";

export const onClientEntry = () => {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search || "");
  if (params.get("ga_debug") !== "1") return;

  // Ensure dataLayer exists early
  window.dataLayer = window.dataLayer || [];

  // Queue debug mode BEFORE any events
  window.dataLayer.push(["set", "debug_mode", true]);
  window.dataLayer.push(["config", "G-T9GQYPB4EP", { debug_mode: true }]);
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_location: location.href,
    page_path: location.pathname,
  });
};
